<template>
  <div class="add-question-by-product-codes">
    <i-tree :data="questionTreeData" expand-node></i-tree>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AddQuestionByProductCodes',
  props: {
    questions: { type: Array, required: true },
  },
  data() {
    return {
      questionTreeData: [],
      questionCounts: [],
    };
  },
  watch: {
    questions: {
      immediate: true,
      handler() {
        this.questions.forEach((question) => {
          if (question.types && question.types.length > 0) {
            question.types.forEach((type) => {
              type.libraryCount = 0;
            });
          }
        });

        this.questionCounts = new Array(this.questions.length).fill(0);

        this.setAddBigQuestionRuleOfProductLibraryTypeList({ list: this.questions });

        this.generateQuestionTreeData(this.questions);
      },
    },
  },
  methods: {
    ...mapActions({
      setAddBigQuestionRuleOfProductLibraryTypeList: 'createPaperStore/invokeSetAddBigQuestionRuleOfProductLibraryTypeList',
    }),
    generateQuestionTreeData(questions) {
      if (!questions || questions.length === 0) {
        this.questionTreeData = [];

        return;
      }

      const _this = this;
      const questionTreeData = [];

      questions.forEach((question, index) => {
        const children = [];

        if (question.types && question.types.length > 0) {
          question.types.forEach((type, typeIndex) => {
            children.push({
              render(h) {
                return [
                  h('span', `${type.libraryType}：`),
                  h('i-input-number', {
                    props: {
                      type: 'number',
                      size: 'small',
                      min: 0,
                      max: type.librarySum,
                      precision: 0,
                      value: 0,
                    },
                    style: {
                      width: '58px',
                      margin: '0 8px',
                    },
                    on: {
                      'on-change': _this.libraryTypeNumChange(index, typeIndex),
                    },
                  }),
                  h('span', `/${type.librarySum}`),
                ];
              },
            });
          });
        }

        questionTreeData.push({
          title: question.shortName,
          expand: index === 0,
          render(h) {
            return [
              h('span',
                {
                  style: {
                    fontWeight: 'bold',
                  },
                },
                question.shortName),
              h('span',
                {
                  style: {
                    fontWeight: 'bold',
                    marginLeft: '12px',
                  },
                },
                _this.questionCounts[index]),
            ];
          },
          children,
        });
      });

      this.questionTreeData = questionTreeData;
    },
    libraryTypeNumChange(index, typeIndex) {
      return (value) => {
        this.questions[index].types[typeIndex].libraryCount = value;

        this.setAddBigQuestionRuleOfProductLibraryTypeList({ list: this.questions });

        this.questions.forEach((question, i) => {
          let count = 0;

          question.types.forEach((type) => {
            count += type.libraryCount;
          });

          this.$set(this.questionCounts, i, count);
        });
      };
    },
  },
};
</script>

<style lang="less" scoped>
.add-question-by-product-codes {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  width: 50%;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #ddd;

  /deep/ .ivu-tree {
    .ivu-tree-title:hover,
    .ivu-tree-title-selected,
    .ivu-tree-title-selected:hover {
      background-color: transparent;
    }

    .ivu-tree-children .ivu-tree-arrow {
      width: 0;
    }

    > .ivu-tree-children > li > .ivu-tree-arrow {
      width: 12px;

      i {
        font-weight: bold;
      }
    }
  }
}
</style>
